<template>
  <el-menu class="el-menu-demo" mode="horizontal" :ellipsis="false">
    <el-menu-item index="0">
      <img style="width: 150px" :src="$store.state.options.logo" alt="Element logo" />
    </el-menu-item>
    <div class="flex-grow" />
    <el-menu-item index="1">欢迎您! {{ $store.state.user.nickName }}</el-menu-item>

    <el-sub-menu index="2" v-if="$store.state.user.is_login">
      <template #title>
        <img
          class="avatar"
          :src="$store.state.user.avatar"
      /></template>
      <el-menu-item index="2-3" @click="logout">退出</el-menu-item>
    </el-sub-menu>

  </el-menu>
</template>
  
  <script setup>
import { onMounted } from "vue";
import $ from "jquery";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from 'vuex';
import router from '@/router/index'
const store = useStore();

onMounted(() => {
  $.ajax({
    type: "post",
    url: "http://124.222.105.205:5000/visitor/api/options/GetOptions",
    data: "",
    success: function (res) {
      if (res.code == 200) {
        console.log(res);
        store.commit('updateOptions', res.data)
      } else {
        console.log("获取配置失败");
      }
    },
  });
});


// 退出登录
const logout = () => {
  ElMessageBox.confirm("是否退出登录?", "退出登录", {
    confirmButtonText: "退出",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      store.dispatch("logout", {
        success() {
          // 处理成功逻辑
          ElMessage({
            type: "success",
            message: "退出成功",
          });
          router.push({ name: "login" });
        },
        error() {
          ElMessage({
            type: "error",
            message: "退出失败",
          });
        },
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消退出",
      });
    });
};
</script>
  
  <style scoped>
.flex-grow {
  flex-grow: 1;
}

.avatar {
  width: 50px;
  border-radius: 30%;
}

.avatar:hover {
  cursor: pointer;
  width: 60px;
  border-radius: 30%;
  transition: 300ms;
}
</style>
  